// Navigation data for Mirage Foods website

export const mainNav = [
  { label: 'HOME', href: '/' },
  { label: 'ABOUT US', href: '/about-us' },
  { label: 'PASTRY MIXES', href: '/pastry-mixes' },
  { label: 'BAKERY MIXES', href: '/bakery-mixes' },
  { label: 'MIRAGE RECIPES', href: '/mirage-recipe' },
  { label: 'MANUFACTURING', href: '/excellence-in-manufacturing' },
  { label: 'Q & A', href: '/q-a' },
  { label: 'CONTACT US', href: '/contact-us' }
];

export const footerQuickLinks = [
  { label: 'HOME', href: '/' },
  { label: 'SUPERIOR PRODUCTS', href: '/superior-products' },
  { label: 'OUR CREDENTIALS', href: '/our-credentials' },
  { label: 'Q&A', href: '/q-a' },
  { label: 'CONTACT US', href: '/contact-us' }
];
